import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Marketing from '../components/Marketing/Marketing';

const MarketingRoute = () => (
    <Routes>
        <Route path="/marketing"
            element={
                <Marketing />
            }>
        </Route>
    </Routes>
);

export default MarketingRoute;
